import type { CustomErrorRule } from '@/core/error/transport/types'
import { TmApiTasksBoardNotFoundError } from '@/core/error/transport/tmApiTasksBoardNotFoundError'

export const tasksBoardNotFoundErrorRule: CustomErrorRule = {
  klass: TmApiTasksBoardNotFoundError,
  predicateFn: (error) => {
    return error.response.data.message.includes('TaskBoard object not found')
  },
}
